import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'controls/Modal'
import { Button } from 'controls'
import styles from './styles'

const DeleteFiscalFileModal = ({
  isShowModal,
  closeModal,
  filePreDelete,
  onClickCancel,
  onClickConfirm
}) => {
  if (!filePreDelete) return null
  return (
    <div>
      <Modal isOpen={isShowModal} onClose={closeModal} showCloseButton>
        <div className="modal-message">
          <p>
            ¿Está seguro que desea borrar el documento:{' '}
            <span className="name-file">{filePreDelete.name || ''}</span>
            ?
          </p>
        </div>
        <div className="button-wrapper">
          <Button
            className="button"
            color="primary"
            size="medium"
            outline
            onClick={onClickCancel}
          >
            Cancelar
          </Button>
          <Button
            className="button"
            color="secondary"
            size="medium"
            outline
            onClick={onClickConfirm}
          >
            Confirmar
          </Button>
        </div>
      </Modal>
      <style jsx>{styles}</style>
    </div>
  )
}

DeleteFiscalFileModal.propTypes = {
  closeModal: PropTypes.func,
  isShowModal: PropTypes.bool,
  filePreDelete: PropTypes.object,
  onClickCancel: PropTypes.func,
  onClickConfirm: PropTypes.func
}

export default DeleteFiscalFileModal
